import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitAssessment = async (payload) => {
  const { data } = await axios.post(`${API}/assessment/submit`, payload);
  return data;
};
